module.exports = __webpack_public_path__ + "static/img/zm.9a7407fb.svg";